export interface ExternalPlanElement {
    elementId: string;
    elementName: string;
    elementType: "task" | "group";
    elementOrder: number;
    task?: {
        id: string;
        start?: string;
        end?: string;
        costs?: number;
        progress?: number;
        status?: string;
        executor?: { name: string; id: string };
    };
    parentElementId?: string;
}

export enum ExternalPlanElementTypes {
    task = "task",
    group = "group",
}
